import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// Format currency in French format
export function formatCurrency(value) {
  if (value === null || value === undefined) return '-';
  return new Intl.NumberFormat('fr-FR', {
    style: 'currency',
    currency: 'EUR',
  }).format(value);
}

// Format date in French format
export function formatDate(dateString) {
  if (!dateString) return '-';
  return new Date(dateString).toLocaleDateString('fr-FR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });
}

// Format datetime in French format
export function formatDateTime(dateString) {
  if (!dateString) return '-';
  return new Date(dateString).toLocaleDateString('fr-FR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

// Format number in French format
export function formatNumber(value) {
  if (value === null || value === undefined) return '-';
  return new Intl.NumberFormat('fr-FR').format(value);
}

// ISO date-only string (YYYY-MM-DD) -> French display (JJ/MM/AAAA). Pure string
// parsing — no Date() round-trip — so it can never shift by a day across timezones.
export function formatDateFr(iso) {
  if (!iso) return '';
  const [y, m, d] = String(iso).split('-');
  return (d && m && y) ? `${d}/${m}/${y}` : '';
}

// "Société - Bon de commande - 12345[- signé le JJ-MM-AAAA]" — the SAME naming
// convention used server-side for the PandaDoc document name and the stored
// PDF, so a downloaded document is always identifiable at a glance.
export function buildDocName(...parts) {
  return parts.filter(Boolean).map(p => String(p).trim()).join(' - ').replace(/[\\/:*?"<>|]/g, '-').trim();
}

// Force a real browser download with a specific filename — window.open on a
// blob URL leaves the browser to pick its own (usually meaningless) name.
export function downloadBlob(data, filename, mimeType = 'application/pdf') {
  const url = URL.createObjectURL(new Blob([data], { type: mimeType }));
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  setTimeout(() => URL.revokeObjectURL(url), 60000);
}
